// Module
var code = "<div class=\"dtp-chart-wrapper\"> <canvas id=\"bar\" class=\"chart chart-bar\" chart-data=\"$ctrl.dataToPPGChart\" chart-labels=\"$ctrl.labels\" chart-series=\"$ctrl.series\" chart-options=\"$ctrl.chartOptions\" chart-dataset-override=\"$ctrl.datasetOverride\"></canvas> </div>";
// Exports
module.exports = code;